
<!--Spinner Add  -->
<div *ngIf="loader" id="cover-spin" class="loader" >
	<!-- <img src="assets/img/spinner.svg">loading.... -->
</div>
<!-- Spinner End -->

